import { Accordion, Box, Flex, Heading, Span } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuArrowDown } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'

const FAQ = () => {


    const cardColor = useColorModeValue('white', 'gray.900')
    //const textGhost = useColorModeValue('gray.800', 'gray.500')
    const {t} = useTranslation()
    const items = [
        { value: "b", title: t('FAQItem1.question'), text: t('FAQItem1.answer') },
        { value: "c", title: t('FAQItem2.question'), text: t('FAQItem2.answer') },
        { value: "d", title: t('FAQItem3.question'), text: t('FAQItem3.answer') }
    ]

  return (
        <Flex
            px={{ md: 'inherit', '2xl': "19%", base: 4 }}
            py={{'2xl' :10, base: 10}}
            overflow={'hidden'}
            position={'relative'}
        >
            <Box w={'full'}>
                <Heading fontSize={{ '2xl': 'xl', md: 'xl', base: 'md' }} textAlign={'center'} fontFamily={'Outfit'} textTransform={'uppercase'}>
                   {t('FAQSubtitle')}
                </Heading>
                <Heading
                    mt={{'2xl': 8, base: 2}}
                    textAlign={'center'}
                    fontWeight={600}
                    letterSpacing={-1.8}
                    fontFamily={'Poppins'}
                    fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
                    lineHeight={1.2}
                >
                {t('FAQTitle')}
                <Span bgGradient={'to-r'}
                    gradientFrom={'blue.500'}
                    gradientTo={'purple.600'}
                    bgClip={'text'}

                > {t('FAQTitleHighlight')}</Span></Heading>

                <Flex flexDir={{md: 'row', base: 'column'}} mt={{md: 20, base: 8}} justify={'center'} gap={{md: 8, base: 0}}>

                    <Accordion.Root collapsible defaultValue={["b"]} w={{base: 'full', md: '450px'}}>
                        {items.map((item, index) => (
                            <Accordion.Item _open={{
                                rounded: 8
                            }} px={8} border={'none'} bgColor={cardColor} rounded={'full'} boxShadow={'sm'} my={2} py={{md: 1, base: 1}} key={index} value={item.value}>
                                <Accordion.ItemTrigger>
                                    <Heading fontFamily={'Onest'} fontSize={{md: 'lg', base: 'md'}} flex="1" letterSpacing={-1.1}>{item?.title}</Heading>
                                    <Accordion.ItemIndicator _open={{
                                        bgColor: 'gray.800',
                                        color: 'white',
                                        p: 2,
                                        rounded: 'full'
                                    }}>
                                        <LuArrowDown/>
                                    </Accordion.ItemIndicator>
                                </Accordion.ItemTrigger>
                                <Accordion.ItemContent>
                                    <Accordion.ItemBody>{item?.text}</Accordion.ItemBody>
                                </Accordion.ItemContent>
                            </Accordion.Item>
                        ))}
                    </Accordion.Root>
                    <Accordion.Root collapsible w={{base: 'full', md: '450px'}}>
                        {items.map((item, index) => (
                            <Accordion.Item _open={{
                                rounded: 8
                            }} px={8} border={'none'} bgColor={cardColor} rounded={'full'} boxShadow={'sm'} my={2} py={{md: 1, base: 1}} key={index} value={item.value}>
                                <Accordion.ItemTrigger>
                                    <Heading fontFamily={'Onest'} fontSize={{md: 'lg', base: 'md'}} flex="1" letterSpacing={-1.1}>{item?.title}</Heading>
                                    <Accordion.ItemIndicator _open={{
                                        bgColor: 'gray.800',
                                        color: 'white',
                                        p: 2,
                                        rounded: 'full'
                                    }}>
                                        <LuArrowDown/>
                                    </Accordion.ItemIndicator>
                                </Accordion.ItemTrigger>
                                <Accordion.ItemContent>
                                    <Accordion.ItemBody>{item?.text}</Accordion.ItemBody>
                                </Accordion.ItemContent>
                            </Accordion.Item>
                        ))}
                    </Accordion.Root>
                </Flex>
            </Box>
        </Flex>
  )
}

export default FAQ